import { useMemo } from 'react';

import { useMediaQuery } from '@mantine/hooks';

interface UseScreenBreakpointOptions {
  getInitialValueInEffect: boolean;
}

export enum MediaQueryType {
  MAX = 'max-width',
  MIN = 'min-width',
}

type BreakPoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const styles = getComputedStyle(document.documentElement);

const BreakPoints: Record<BreakPoint, string> = {
  sm: styles.getPropertyValue('--breakpoint-sm'),
  md: styles.getPropertyValue('--breakpoint-md'),
  lg: styles.getPropertyValue('--breakpoint-lg'),
  xl: styles.getPropertyValue('--breakpoint-xl'),
  '2xl': styles.getPropertyValue('--breakpoint-2xl'),
};

export const useScreenBreakpoint = (
  breakpoint: BreakPoint,
  mediaQuery: MediaQueryType = MediaQueryType.MIN,
  initialValue?: boolean,
  options?: UseScreenBreakpointOptions
) => {
  const query = `(${mediaQuery}:${BreakPoints[breakpoint]})`;

  /** pass this to useMediaQuery initialValue */
  const initValue = useMemo(() => {
    if (typeof initialValue === 'boolean') return initialValue;

    if ('matchMedia' in window) {
      return window.matchMedia(query).matches;
    }
    return undefined;
  }, [initialValue, query]);

  return useMediaQuery(query, initValue, options);
};
